import React from 'react';
import * as Scroll from 'react-scroll';
import {Events} from 'react-scroll';
import './app.styles.scss';
import * as Google from '@vis.gl/react-google-maps';

import whiteLogo from '../../assets/images/favicon.svg';
import markerImg from '../../assets/images/map-marker.svg';
import {NavLink} from 'react-router-dom';

class App extends React.Component {
    state = {
        currentBlock: 0,
    }
    isBlockLoading = false;
    block = 0
    blocksIds = ['believe__block', 'about-the-company__block', 'contacts__block']
    menuItems = new Map<string, string>([
        ['О компании', 'about-the-company__block'],
        ['Контакты', 'contacts__block']
    ])

    componentDidMount() {
        if (window.innerWidth > 1023) {
            window.addEventListener('DOMMouseScroll', preventDefault, {passive: false}); // older FF
            window.addEventListener('wheel', preventDefault, {passive: false}); // older FF
            window.addEventListener('touchmove', preventDefault, {passive: false}); // mobile

            this.scroll();

            document.addEventListener('wheel', (e) => {
                if (!this.isBlockLoading) {
                    if (e.deltaY > 0 && this.block < this.blocksIds.length - 1) {
                        this.block += 1;
                        this.scroll();
                    } else if (e.deltaY < 0 && this.block > 0) {
                        this.block -= 1;
                        this.scroll();
                    }
                }
            });
        }
    }

    scroll() {
        this.isBlockLoading = true

        Events.scrollEvent.register('end', () => {
            this.setState({currentBlock: this.block})
            this.isBlockLoading = false;
            Events.scrollEvent.remove('end');
        });

        Scroll.scroller.scrollTo(this.blocksIds[this.block], {
            duration: 1000,
            delay: 100,
            smooth: 'easeInOutQuint'
        });
    }

    render() {
        return <div className='App'>
            <div id='menu-shadow'></div>
            <div className='menu-wrapper' id='menu'>
                <div id='menu-close' onClick={() => {
                    document.getElementById('menu')!!.className = 'menu-wrapper'
                }}/>
                <ul>
                    <li><NavLink to={'/authorization'}>Личный кабинет</NavLink></li>
                    {Array.from(this.menuItems.keys()).map((title, i) => {
                        return <li key={i} onClick={() => {
                            if (!this.isBlockLoading) {
                                const blockId = this.menuItems.get(title);
                                this.block = this.blocksIds.indexOf(blockId!!);
                                this.scroll();
                            }
                        }}>{title}</li>;
                    })}
                </ul>
            </div>
            <div
                className={document.getElementById(this.blocksIds[this.state.currentBlock])?.className.includes('white') ? 'section-header white' : 'section-header'}
                id='header'>
                <div className='section-container'>
                    <div className={`header-phone ${this.state.currentBlock === 0 ? 'light' : ''}`}>
                        <a href='tel:+74957866060'>+7 495 786 60 60</a>
                        <div className='menu-bottom' id='menu' onClick={() => {
                            document.getElementById('menu')!!.className = 'menu-wrapper active'
                        }}>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            </div>
            <div className='section section-image' data-section-name='believe' id='believe__block' style={{
                backgroundImage: 'url(' + require('../../assets/images/img_screen1.jpg') + ')',
                height: (window.innerWidth > 1023) ? '100vh' : 'calc(100vh - 87px)'
            }} onClick={() => {
                document.getElementById('menu')!!.className = 'menu-wrapper'
            }}>
                <div className='section-container'>
                    <div className='content-block'>
                        <div id='main-logo' className='text-center'><img alt='logo white' src={whiteLogo}/></div>
                    </div>
                </div>
            </div>
            <div className='section section-content' data-section-name='about-the-company' id='about-the-company__block'
                 style={{
                     height: (window.innerWidth > 1023) ? '100vh' : undefined
                 }}
                 onClick={() => {
                     document.getElementById('menu')!!.className = 'menu-wrapper'
                 }}>
                <div className='section-container'>
                    <div className='content-block one-column'>
                        <div className='content-block__header'>О компании</div>
                        <p>
                            Многолетний опыт работы с частными клиентами и ведение корпоративных проектов в таких
                            сферах, как банковское обслуживание, девелопмент, платежные системы, мобильная связь,
                            производство автомобилей, авиаперевозки, искусство и другие, позволяет нам быть лидером
                            консьерж-услуг в России.
                        </p>
                        <p>
                            Мы успешно масштабируем свои услуги, обслуживая одновременно тысячи клиентов и при этом
                            сохраняя личный, доверительный подход к каждому запросу.
                        </p>
                    </div>
                </div>
            </div>
            <div className='section section-content' data-section-name='contacts' id='contacts__block' style={{
                height: (window.innerWidth > 1023) ? '100vh' : undefined,
                padding: (window.innerWidth > 1023) ? 0 : '24px 0 0 0'
            }} onClick={() => {
                document.getElementById('menu')!!.className = 'menu-wrapper'
            }}>
                <div className='section-container' style={{margin: 0, width: 'auto'}}>
                    <div className='MapWrapper'>
                        {/*<div className='content-block__header'>Контакты</div>*/}
                        <Google.APIProvider apiKey={'AIzaSyDv8N8UFIE9MmH9WY0wpNzk9G-1ih3JyEE'}>
                            <Google.Map
                                mapId={'aeb3a939218f6844'}
                                defaultCenter={{lat: 55.807965, lng: 37.449649}}
                                defaultZoom={15}
                                disableDefaultUI={true}
                                className='MapWrapper-Map'
                            >
                                <Google.AdvancedMarker
                                    position={{lat: 55.807965, lng: 37.449649}}
                                >
                                    <img src={markerImg} alt={'marker'}/>
                                </Google.AdvancedMarker>
                            </Google.Map>
                        </Google.APIProvider>
                        <div className='MapWrapper-Info'>
                            <div className='MapWrapper-Arrow'></div>
                            <div className='MapWrapper-TopInfo'>
                                <div className='MapWrapper-Address'>123182 Москва, ул. Авиационная 77/5, БЦ «Алые
                                    Паруса»
                                </div>
                                <div className='MapWrapper-Phones'>
                                    <a href='tel:+74957866060'>
                                        +7 495 786 60 60
                                    </a>
                                </div>
                            </div>
                            <hr className='MapWrapper-Delimiter'/>
                            <div className='MapWrapper-BottomInfo'>
                                <div className='MapWrapper-Mails'>
                                    <div>Стать клиентом или партнёром</div>
                                    <a href='mailto:info@apcg.com'>
                                        info@apcg.com
                                    </a>
                                </div>
                            </div>
                            <div className='MapWrapper-Requisites'>
                                <div>Общество с ограниченной ответственностью "Квинтессеншиалли Нова"</div>
                                <div>ИНН 7714914997</div>
                                <div>ОГРН 1137746805437</div>
                                <div>Расчетный счет № 40702810838000049395 ПАО Сбербанк</div>
                                <div>Юридический адрес: 123182, город Москва, Авиационная ул., д. 77, эт 3 пом II ком 37
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-menu">
                        <ul>
                            <li>
                                <a href="https://static.konsierge.com/docs/public_offer_apcg" target="_blank" rel="noreferrer">
                                    Договор оферты
                                </a>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <a href="https://static.konsierge.com/docs/policy_apcg" target="_blank" rel="noreferrer">
                                    Политика обработки персональных данных
                                </a>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <a href="https://static.konsierge.com/docs/agreement_apcg" target="_blank" rel="noreferrer">
                                    Согласие на обработку персональных данных
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>;
    }
}

function preventDefault(e: any) {
    e.preventDefault();
}

export default App;
